import { decorateTripsterUrl } from '@/lib/affiliates/utils/tripster';
import { buildViatorCountryLink } from '@/lib/affiliates/builders/viator';

// Города, у которых на Tripster есть своя страница (проверено браузером 01.10.2026: заголовок
// «Экскурсии в …»); для остальных — страница страны /destinations/<страна>/.
export const TRIPSTER_CITY = {
    berat: 'Berat', durres: 'Durres', saranda: 'Saranda', tirana: 'Tirana',
    batumi: 'Batumi', borjomi: 'Borjomi', gudauri: 'Gudauri', kutaisi: 'Kutaisi', mtskheta: 'Mtskheta', tbilisi: 'Tbilisi',
    bar: 'Bar', budva: 'Budva', 'herceg-novi': 'Herceg_Novi', kotor: 'Kotor', perast: 'Perast', petrovac: 'Petrovac',
    podgorica: 'Podgorica', tivat: 'Tivat',
    doha: 'Doha',
    bled: 'Bled', ljubljana: 'Ljubljana', piran: 'Piran',
    basel: 'Basel', geneva: 'Geneva', lausanne: 'Lausanne', lucerne: 'Lucerne', lugano: 'Lugano', montreux: 'Montreux', zurich: 'Zurich',
};

/** Страница туров Tripster для города (или страны), с партнёрскими параметрами. */
export function tripsterCityUrl(citySlug, country, utmTerm) {
    const base = TRIPSTER_CITY[citySlug]
        ? `https://experience.tripster.ru/experience/${TRIPSTER_CITY[citySlug]}/`
        : `https://experience.tripster.ru/destinations/${country}/`;
    return decorateTripsterUrl(base, utmTerm);
}

/**
 * Ссылка на туры города у провайдера карточки: Tripster — страница города, Viator — направление
 * города (providerRefs.viator). null — города у провайдера нет, берётся ссылка страны.
 */
export function providerCityToursUrl(provider, { citySlug, country, viatorRef, utmTerm } = {}) {
    if (!provider?.code || !citySlug) return null;
    if (provider.code === 'tripster' && TRIPSTER_CITY[citySlug]) return tripsterCityUrl(citySlug, country, utmTerm);
    if (provider.code === 'viator' && viatorRef?.destinationId && viatorRef?.pathSegment) {
        return buildViatorCountryLink({ pathSegment: viatorRef.pathSegment, destinationId: viatorRef.destinationId, affiliateProvider: provider });
    }
    return null;
}
